export function requiredElement<T extends Element>(selector: string, root: ParentNode = document): T {
  const element = root.querySelector<T>(selector);
  if (!element) throw new Error(`No se encontró el elemento requerido: ${selector}`);
  return element;
}

export function openDialog(id: string): void {
  requiredElement<HTMLDialogElement>(`#${id}`).showModal();
}

export function refreshIcons(): void {
  window.lucide?.createIcons();
}
